import type React from 'react';

import { Image } from '@change/ds-core-ui';

import { useIsMobile } from '#src/app/shared/hooks/userAgent';

import { usePetitionUpdateMedia } from './hooks/usePetitionUpdateMedia';

export const PetitionUpdateMedia: React.FC = () => {
	const {
		data: { photo },
	} = usePetitionUpdateMedia();

	const isMobile = useIsMobile();
	const imgSrc = isMobile ? photo?.mobileUrl : photo?.url;

	if (photo) {
		return (
			<Image
				aspectRatio="16:9"
				alt=""
				className="w-full rounded-lg align-top md:w-[600px]"
				src={imgSrc}
				srcSet={`${photo.mobileUrl} 600w, ${photo.url} 1200w`}
				data-qa="petition-update-photo"
				data-testid="petition-update-photo"
			/>
		);
	}

	return null;
};
